module.exports = __webpack_public_path__ + "media/audio6.1754b4bb.wav";